<ng-container *ngIf="newCatSystemVersion(catSystemVersion) && groups && groups.length > 0">
    <div class="t-panel-cell">
        <div>

            <ng-container *ngFor="let group of groups">


                <input-wrap [label]="group.groupLabel" cssClass="l-cell-spread" [required]="group.isRequired">
                    <ng-container *ngIf="group.isMultiValued; else singleValue">

                        <p-multiSelect [options]="docMetadataByGroup[group.groupName]" class="l-cell-spread-x"
                            [(ngModel)]="selections[group.groupName]" optionLabel="fieldLabel" [filter]="true"
                            [disabled]="docMetadataHandler.isFormControlDisabled(group)"
                            [required]="group.isRequired"
                            [showClear]="!readonly"
                            appendTo="body"
                            [readonly]="readonly"
                            [resetFilterOnHide]="true" [autofocusFilter]="true" filterBy="fieldLabel"></p-multiSelect>
                    </ng-container>

                    <ng-template #singleValue>
                        <p-select [options]="docMetadataByGroup[group.groupName]" class="l-cell-spread-x"
                        [disabled]="docMetadataHandler.isFormControlDisabled(group)"
                        [required]="group.isRequired"
                        appendTo="body"
                        [readonly]="readonly"
                        [showClear]="!readonly"
                            [(ngModel)]="selections[group.groupName]" optionLabel="fieldLabel"></p-select>
                    </ng-template>
                </input-wrap>

            </ng-container>
        </div>
    </div>
</ng-container>